import React, { useState } from 'react';
import { FaFacebook, FaInstagram, FaTiktok, FaChevronDown } from 'react-icons/fa';

const Footer = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <footer className="footer__section footer__bg">
      <div className="container-fluid">
        <div className="main__footer">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="footer__widget">
                <h2 className="footer__widget--title d-flex justify-content-between align-items-center" onClick={() => toggleSection('about')}>
                  <span>About Us</span>
                  <FaChevronDown 
                    size={20}
                    style={{ 
                      transform: openSection === 'about' ? 'rotate(180deg)' : 'rotate(0)',
                      transition: 'transform 0.3s ease'
                    }} className='block sm:hidden'
                  />
                </h2>
                <div className={`footer__widget--inner ${openSection === 'about' ? 'd-block' : 'd-none d-md-block'}`}>
                  <a className="footer__logo -mb-8 -mt-12" href="/">
                    <img
                      src="../assets/img/logo/glorious_1.webp"
                      alt="footer-logo"
                      style={{ width: '200px' }}
                    />
                  </a>
                  <p className="footer__widget--desc">
                    Discover premium salon and spa <br />
                    equipment designed to elevate your space. where comfort, style, and <br />
                    durability come together to create <br /> a lasting impression.
                  </p>
                  <div className="footer__social">
                    <ul className="social__shear d-flex">
                      <li className="social__shear--list">
                        <a
                          className="social__shear--list__icon"
                          target="_blank" rel="noopener noreferrer"
                          href="https://web.facebook.com/profile.php?id=61556289781723"
                        >
                          <FaFacebook size={20} />
                        </a>
                      </li>
                      <li className="social__shear--list">
                        <a
                          className="social__shear--list__icon"
                          target="_blank" rel="noopener noreferrer"
                          href="https://www.instagram.com/gloriousevidenceofficial/"
                        >
                          <FaInstagram size={20} />
                        </a>
                      </li>
                      <li className="social__shear--list">
                        <a
                          className="social__shear--list__icon"
                          target="_blank" rel="noopener noreferrer"
                          href="https://www.tiktok.com/@gloriousevidenceofficial?_t=ZN-8ujr7nVT0vW&_r=1"
                        >
                          <FaTiktok size={20} />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="footer__widget">
                <h2 className="footer__widget--title d-flex justify-content-between align-items-center" onClick={() => toggleSection('quickLinks')}>
                  <span>Quick Links</span>
                  <FaChevronDown 
                    size={20}
                    style={{ 
                      transform: openSection === 'quickLinks' ? 'rotate(180deg)' : 'rotate(0)',
                      transition: 'transform 0.3s ease'
                    }} className='block sm:hidden'
                  />
                </h2>
                <ul className={`footer__widget--menu footer__widget--inner ${openSection === 'quickLinks' ? 'd-block' : 'd-none d-md-block'}`}>
                  <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/about_us">About Us</a>
                  </li>
                  <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/wishlist">Wishlist</a>
                  </li>
                  <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/contact_us">Contact Us</a>
                  </li>
                  <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/policy">Privacy Policy</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="footer__widget">
                <h2 className="footer__widget--title d-flex justify-content-between align-items-center" onClick={() => toggleSection('accountInfo')}>
                  <span>Account Info</span>
                  <FaChevronDown 
                    size={20}
                    style={{ 
                      transform: openSection === 'accountInfo' ? 'rotate(180deg)' : 'rotate(0)',
                      transition: 'transform 0.3s ease'
                    }} className='block sm:hidden'
                  />
                </h2>
                <ul className={`footer__widget--menu footer__widget--inner ${openSection === 'accountInfo' ? 'd-block' : 'd-none d-md-block'}`}>
                  <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/auth/signin">My Account</a>
                  </li>
                  <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/cart">Shopping Cart</a>
                  </li>
                  <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/auth/signin">Login / Register</a>
                  </li>
                  <li className="footer__widget--menu__list">
                    <a className="footer__widget--menu__text" href="/user_dashboard/cart">Checkout</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="footer__widget">
                <h2 className="footer__widget--title d-flex justify-content-between align-items-center" onClick={() => toggleSection('newsletter')}>
                  <span>Quick Response</span>
                  <FaChevronDown 
                    size={20}
                    style={{ 
                      transform: openSection === 'newsletter' ? 'rotate(180deg)' : 'rotate(0)',
                      transition: 'transform 0.3s ease'
                    }} className='block sm:hidden'
                  />
                </h2>
                <div className={`footer__newsletter footer__widget--inner ${openSection === 'newsletter' ? 'd-block' : 'd-none d-md-block'}`}>
                  <p className="footer__newsletter--desc leading-10">
                   We are always available for <br /> 
                   you and you can
                   Just call,<br /> email or chat us for business
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer__bottom d-flex justify-content-between align-items-center">
          <p className="copyright__content m-0">
            Copyright © 2025
            <a className="copyright__content--link" href="/">Glorious Evidence</a>{' '}
            . All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
